module.exports = __webpack_public_path__ + "img/L_316_326.6d3e83c3.png";